import { cn } from "@babybjorn/ui";
import { useContext, useEffect, type FC, type HTMLAttributes } from "react";
import Icon from "../../../Icon";
import { AccordionContext } from "../../Accordion";
import * as s from "./AccordionBar.module.scss";

type AccordionBarProps = HTMLAttributes<HTMLButtonElement> & {
	label: string;
	icon?: string;
	secondaryLabel?: string;
	accordionIndex: string;
	fullWidth?: boolean;
	openByDefault?: boolean | null;
};

const AccordionBar: FC<AccordionBarProps> = ({
	label,
	icon,
	accordionIndex,
	secondaryLabel,
	openByDefault,
	fullWidth,
	...rest
}) => {
	const [state, dispatch] = useContext(AccordionContext);

	useEffect(() => {
		if (openByDefault) {
			dispatch({ type: "setOpen", key: accordionIndex });
		}
	}, [openByDefault, accordionIndex, dispatch]);

	return (
		<button
			aria-label={label}
			className={cn(s.container, { [s.fullWidth]: fullWidth })}
			onClick={() => dispatch({ type: "setOpen", key: accordionIndex })}
			{...rest}
		>
			<span className="text-left">
				{icon && <Icon icon={icon} />}
				{label}
			</span>
			<div>
				{secondaryLabel && Boolean(!state[accordionIndex]) && (
					<span>{secondaryLabel}</span>
				)}
				<Icon
					icon="arrow-down"
					className={cn(s.icon, {
						[s.open]: Boolean(state[accordionIndex]),
					})}
				/>
			</div>
		</button>
	);
};

export default AccordionBar;
